import * as Yup from 'yup';

function haveFiles(files) {
  return files && files.length > 0;
}

export default Yup.object({
  proofOfAddress: Yup.mixed().test(
    'some files',
    'schemas:kyc.proofOfAddress.required',
    haveFiles
  ),
  typeOfDocument: Yup.mixed().test(
    'test-selected',
    'errors:required',
    value => value !== ''
  )
});
